import { CheckCircle2 } from "lucide-react";

/**
 * Post-Stripe-checkout return banner. Renders when the URL query has
 *   ?academy=welcome   (payment received)
 *   ?academy=cancelled (payment cancelled)
 * Otherwise renders nothing.
 */
export function WelcomeBanner({ state, planId, onDismiss }) {
    if (state === "welcome") {
        return (
            <div
                className="border-b border-weave-teal bg-[#e8f3f3]"
                data-testid="academy-welcome-banner"
            >
                <div className="max-w-5xl mx-auto px-6 md:px-10 py-5 flex flex-wrap items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                        <CheckCircle2 className="w-5 h-5 text-weave-teal shrink-0" />
                        <div>
                            <p className="editorial-label text-weave-teal">
                                Welcome to the Academy
                            </p>
                            <p className="text-sm text-weave-ink mt-1">
                                Payment received{planId ? ` — ${planId} plan` : ""}. A
                                confirmation is on its way, and we'll reach out with your
                                cohort details shortly.
                            </p>
                        </div>
                    </div>
                    <button
                        onClick={onDismiss}
                        className="text-xs uppercase tracking-editorial text-weave-slate hover:text-weave-ink"
                        data-testid="dismiss-welcome"
                    >
                        Dismiss
                    </button>
                </div>
            </div>
        );
    }
    if (state === "cancelled") {
        return (
            <div
                className="border-b border-weave-border bg-weave-surface-alt"
                data-testid="academy-cancelled-banner"
            >
                <div className="max-w-5xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between gap-4">
                    <p className="text-sm text-weave-slate">
                        Checkout cancelled — no charge made. Take another look whenever
                        you're ready.
                    </p>
                    <button
                        onClick={onDismiss}
                        className="text-xs uppercase tracking-editorial text-weave-slate hover:text-weave-ink"
                    >
                        Dismiss
                    </button>
                </div>
            </div>
        );
    }
    return null;
}
